/**
 * Created by c_razmuss_a on 12/10/2017.
 */
'use strict';

var $ = require('jquery');
require('bootstrap');
var positioning = require('vhi-ui-framework/src/main/js/utilities/positioning');
var groupSchemeService = require('./services/groupSchemeService');
var header = require('shared/scripts/modules/utils/header');
var footer = require('vhi-ui-framework/src/main/js/layout/corporateFooter');
var loginStatusService = require('shared/scripts/modules/loginStatusService');

function init(isLoginLogoutCta) {
    // Show/hide logout CTA
    var headerCb = (isLoginLogoutCta === true) ? header.initWithLoginCta : header.init;
    var loggedInPromise = loginStatusService.getIsUserLoggedIn();
    loggedInPromise.done(function(isLoggedIn) {
        headerCb(isLoggedIn, true);
    });

    var contactInfoPromise = groupSchemeService.getContactInformation();
    contactInfoPromise.done(footer.init);

    positioning.sameHeightConfig.minWidth = 0;
    positioning.registerSameHeightListener();

    return $.when(contactInfoPromise, loggedInPromise);
}

module.exports.init = init;



//////////////////
// WEBPACK FOOTER
// ./src/main/scripts/modules/usualPageSetup.js
// module id = RVtR
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16